
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faHeadset } from "@fortawesome/free-solid-svg-icons";

export default function StickyActions() {

    return (
        <>
            <div className="fixed bottom-32 right-6 
tablet:top-6 tablet:right-6 
z-50 flex flex-col gap-2">
                <div
                    role="button"
                    aria-label="Call toll free number"
                    onClick={(e) => {
                        e.stopPropagation();

                        // Optional: analytics tracking
                        if (window.gtag) {
                            window.gtag("event", "toll_free_call_click", {
                                event_category: "engagement",
                                event_label: "floating_toll_free_button",
                            });
                        }

                        window.location.href = "tel:18005711101";
                    }}
                    className="w-10 h-10 rounded-full bg-[#00A786]
    flex items-center justify-center text-white shadow-lg
    text-xl cursor-pointer pulse-bg"
                    title="Toll Free Number"
                >
                    <FontAwesomeIcon icon={faHeadset} size="lg" />
                </div>
            </div>
            <div className="fixed bottom-10 right-6 z-50 flex flex-col gap-1">

                {/* WhatsApp */}
                <a
                    href="https://wa.me/918754468400"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-[#25D366]
    flex items-center justify-center text-white shadow-lg
    text-xl font-semibold pulse-bg"
                    aria-label="WhatsApp"
                >
                    <FontAwesomeIcon icon={faWhatsapp} size="lg" />
                </a>

                {/* Call */}
                <div
                    role="button"
                    aria-label="Call"
                    onClick={() => {
                        gtag("event", "phone_call_click", {
                            event_category: "engagement",
                            event_label: "floating_call_button",
                        });

                        window.location.href = "tel:+918754468400";
                    }}
                    className="w-10 h-10 rounded-full bg-[#00A786]
    flex items-center justify-center text-white shadow-lg
    text-xl cursor-pointer pulse-bg"
                    title="Call us"
                >
                    <FontAwesomeIcon icon={faPhone} size="xs" />
                </div>


            </div>

        </>
    );
}
